var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('router-view'),(_vm.loading)?_c('van-loading',{staticClass:"my-loading",attrs:{"size":"56px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }